<div class="container">
  <button class="navbar-toggler" type="button" (click)="toggle()">&#9776;</button>
  <div class="collapse navbar-collapse" [class.show]="isExpanded">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item"><a class="nav-link" href="/"><fa-icon [icon]="faHome"></fa-icon></a></li>
      @if (canRegisterDeathSurvey) {
        <li class="nav-item"><a class="nav-link" (click)="nav.navigateTo('Dödsfall')">Dödsfall</a></li>
      }
      @if (canRegisterUnitSurvey) {
        <li class="nav-item"><a class="nav-link" (click)="nav.navigateTo('Enhetsenkät')">Enhetsenkät</a></li>
      }
      @if (isAuthenticated) {
        <li class="nav-item"><a class="nav-link" (click)="nav.navigateToNewWindow('Utdata')">Utdata</a></li>
      }
      @if (hasAdminMenu) {
        <li ngbDropdown class="nav-item" role="presentation">
          <button type="button" class="nav-link link-light" ngbDropdownToggle>Administration</button>
          <div ngbDropdownMenu>
            @if (canHandleUsers) {
              <button ngbDropdownItem (click)="nav.navigateTo('AdminAnvändare')">Användare</button>
            }
            @if (canHandleUsers) {
              <button ngbDropdownItem (click)="nav.navigateTo('AdminEnheter')">Enheter</button>
            }
            @if (canHandleMessages) {
              <button ngbDropdownItem (click)="nav.navigateTo('AdminAktörer')">Aktörer</button>
            }
            @if (canHandleMessages) {
              <button ngbDropdownItem (click)="nav.navigateTo('HanteraMeddelande')">Hantera meddelanden</button>
            }
            @if (canHandleUsers&&isAdvanced) {
              <button ngbDropdownItem (click)="nav.navigateTo('AdminÄndring')">Hantera förfrågningar</button>
            }
            @if (canHandleUsers) {
              <button ngbDropdownItem (click)="nav.navigateTo('AdminEnhetsändring')">Kommande enhetsändringar</button>
            }
            @if (canHandlePatients) {
              <button ngbDropdownItem (click)="nav.navigateTo('AdminPatienter')">Hantera patienter</button>
            }
            @if (canHandleDataExtracts) {
              <button ngbDropdownItem (click)="nav.navigateTo('HanteraDatauttag')">Hantera datauttag</button>
            }
          </div>
        </li>
      }
    </ul>
  </div>
</div>
